<shared-link *ngIf="(locationName$ | async)" class="cart-location-button" [label]="(collectionTypeLabel$ | async)"
    [inverted]="true" (onClick)="onLocationClick($event)">

    {{(locationName$ | async) | truncate: 0 : 15 : '...' : false}}</shared-link>
